import React from 'react';
import PropTypes from 'prop-types';
import {formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';

import AddRemoveListExt from '../../../../../Common/Controls/AddRemoveListExt/addRemoveListExt';
import PdfLabelPropertyListItem from '../../../../SettingsPage/PdfLabelSettings/Components/PdfLabelPropertyListItem/pdfLabelPropertyListItem';

require('./pdfDetailedLabelSectionForm.scss');

class PdfDetailedLabelSectionFormBase extends React.PureComponent {

  constructor(props) {
    super(props);
    this.labels = this.props.labels;
  }

  componentDidMount() {
    if (this.props.onHandleSubmitReady) {
      this.props.onHandleSubmitReady(this.props.handleSubmit);
    }
  }

  getPdfLabelPropertyListItem = (itemProps) => {
    const fieldsValues = this.props.fieldsValues;
    const isBusinessID = fieldsValues && fieldsValues[itemProps.index]
      ? fieldsValues[itemProps.index].propertyType === 'businessId'
      : false;
    return <PdfLabelPropertyListItem {...itemProps} isBusinessID={isBusinessID}/>
  }

  render() {

    let {formData, sectionTitle, listFieldName} = this.props;
    if (!formData) {
      return null;
    }

    let allOptions = formData.pdfOptions;
    let settings = formData.pdfData.settings;
    let preSelectedItemsIds = settings ? settings.map((item) => {
      return (item.property ? item.property.id : item.additionalField ? item.additionalField.id : null);
    }) : [];

    return (
      <div className='pdf-detailed-label-section-form'>
        <div className="section-title">{sectionTitle}</div>

        <div className="properties-list-header">
          <label className="column">{this.labels.get('list.column.property')}</label>
          <label className="column column-2">{this.labels.get('list.column.fontFormat')}</label>
        </div>

        <AddRemoveListExt
          {...this.props}
          name={listFieldName}
          itemRendererComponent={this.getPdfLabelPropertyListItem}
          itemRendererOptions={allOptions}
          preSelectedItemsIds={preSelectedItemsIds}
          addButtonLabel={this.labels.get('list.button.add')}
          defaultItem={{fontSize: 9}}
          maxItemsToOverflow={1000}
        />
      </div>
    );
  }
}

PdfDetailedLabelSectionFormBase.propTypes = {
  formData: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
  sectionTitle: PropTypes.string.isRequired,
  listFieldName: PropTypes.string.isRequired,
};

export function createPdfDetailedLabelSectionForm(formName, listFieldName) {
  let FormComponent = reduxForm({
    form: formName,
    enableReinitialize: true,
  })(PdfDetailedLabelSectionFormBase);

  const selector = formValueSelector(formName);

  FormComponent = connect(state => {
    return { fieldsValues: selector(state, listFieldName) };
  })(FormComponent);

  return FormComponent;
}

export function computeInitialValues(formData, listFieldName) {
  if (!formData || !formData.pdfData) {
    return {};
  }

  if (!formData.pdfData.settings) {
    return {};
  }

  let list = formData.pdfData.settings.map((item) => {
    return {
      propertyName: (item.property ? item.property.id : item.additionalField ? item.additionalField.id : null),
      fontSize: item.fontFormat,
      fontBold: item.isBold,
      printBarcode: item.printBarcode,
      propertyType: item?.property?.propertyName
    }
  });

  return {[listFieldName]: list};
}

export function convertToSettings(pdfLabelsList, pdfOptions) {
  if (!pdfLabelsList) {
    return [];
  }

  return pdfLabelsList.map((item, index) => {
    let option = pdfOptions.find((op) => { return op.data.id === item.propertyName });
    return {
      optionId: item.propertyName,
      fontFormat: item.fontSize,
      isBold: !!item.fontBold,
      printBarcode: !!item.printBarcode,
      isAdditionalField: (option && option.data ? option.data.isAdditionalField : false),
      columnChar: '' + (index + 1),
      columnIndex: index + 1,
    };
  });
}
